"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerspectiveDataProvider = exports.PERSPECTIVE_PAGE_SIZE = void 0;
const debug_1 = __importDefault(require("debug"));
exports.PERSPECTIVE_PAGE_SIZE = 100;
const dbg = (0, debug_1.default)('dbgate:PerspectiveDataProvider');
class PerspectiveDataProvider {
    constructor(cache, loader, dataPatterns) {
        this.cache = cache;
        this.loader = loader;
        this.dataPatterns = dataPatterns;
    }
    loadData(props) {
        return __awaiter(this, void 0, void 0, function* () {
            dbg('load data', props);
            // console.log('LOAD DATA', props);
            if (props.bindingColumns) {
                return this.loadDataNested(props);
            }
            else {
                return this.loadDataFlat(props);
            }
        });
    }
    loadDataNested(props) {
        return __awaiter(this, void 0, void 0, function* () {
            const tableCache = this.cache.getTableCache(props);
            // console.log('loadDataNested', props);
            const uncached = tableCache.getUncachedBindingGroups(props);
            if (uncached.length > 0) {
                const counts = yield this.loader.loadGrouping(Object.assign(Object.assign({}, props), { bindingValues: uncached }));
                // console.log('loadDataNested COUNTS', counts);
                for (const resetItem of uncached) {
                    tableCache.storeGroupSize(props, resetItem, 0);
                }
                for (const countItem of counts) {
                    const { _perspective_group_size_ } = countItem, fields = __rest(countItem, ["_perspective_group_size_"]);
                    tableCache.storeGroupSize(props, props.bindingColumns.map(col => fields[col]), _perspective_group_size_);
                }
            }
            const rows = [];
            // console.log('CACHE', tableCache.bindingGroups);
            let groupIndex = 0;
            let loadCalled = false;
            let shouldReturn = false;
            for (; groupIndex < props.bindingValues.length; groupIndex++) {
                const groupValues = props.bindingValues[groupIndex];
                const group = tableCache.getBindingGroup(groupValues);
                if (!group.loadedAll) {
                    if (loadCalled) {
                        shouldReturn = true;
                    }
                    else {
                        // we need to load next data
                        yield this.loadNextGroup(props, groupIndex);
                        loadCalled = true;
                    }
                }
                // console.log('GRP', groupValues, group);
                rows.push(...group.loadedRows);
                if (rows.length >= props.topCount || shouldReturn) {
                    return {
                        rows: rows.slice(0, props.topCount),
                        incomplete: props.topCount < rows.length || !group.loadedAll || groupIndex < props.bindingValues.length - 1,
                    };
                }
            }
            if (groupIndex >= props.bindingValues.length) {
                // all groups are fully loaded
                return { rows, incomplete: false };
            }
        });
    }
    loadNextGroup(props, groupIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            const tableCache = this.cache.getTableCache(props);
            const planLoadingGroupIndexes = [];
            const planLoadingGroups = [];
            let planLoadRowCount = 0;
            const loadPlanned = () => __awaiter(this, void 0, void 0, function* () {
                // console.log(
                //   'LOAD PLANNED',
                //   planLoadingGroupIndexes,
                //   planLoadingGroupIndexes.map(idx => props.bindingValues[idx])
                // );
                const rows = yield this.loader.loadData(Object.assign(Object.assign({}, props), { bindingValues: planLoadingGroupIndexes.map(idx => props.bindingValues[idx]) }));
                // console.log('LOADED PLANNED', rows);
                // distribute rows into groups
                for (const row of rows) {
                    const group = planLoadingGroups.find(x => x.matchRow(row));
                    if (group) {
                        group.loadedRows.push(row);
                    }
                }
                for (const group of planLoadingGroups) {
                    group.loadedAll = true;
                }
            });
            for (; groupIndex < props.bindingValues.length; groupIndex++) {
                const groupValues = props.bindingValues[groupIndex];
                const group = tableCache.getBindingGroup(groupValues);
                if (!group)
                    continue;
                if (group.loadedAll)
                    continue;
                if (group.groupSize == 0) {
                    group.loadedAll = true;
                    continue;
                }
                if (group.groupSize >= exports.PERSPECTIVE_PAGE_SIZE) {
                    if (planLoadingGroupIndexes.length > 0) {
                        yield loadPlanned();
                        return;
                    }
                    const nextRows = yield this.loader.loadData(Object.assign(Object.assign({}, props), { topCount: null, range: {
                            offset: group.loadedRows.length,
                            limit: exports.PERSPECTIVE_PAGE_SIZE,
                        }, bindingValues: [group.bindingValues] }));
                    group.loadedRows = [...group.loadedRows, ...nextRows];
                    group.loadedAll = nextRows.length < exports.PERSPECTIVE_PAGE_SIZE;
                    return;
                }
                else {
                    if (planLoadRowCount + group.groupSize > exports.PERSPECTIVE_PAGE_SIZE) {
                        yield loadPlanned();
                        return;
                    }
                    planLoadingGroupIndexes.push(groupIndex);
                    planLoadingGroups.push(group);
                    planLoadRowCount += group.groupSize;
                }
            }
            if (planLoadingGroupIndexes.length > 0) {
                yield loadPlanned();
            }
        });
    }
    loadDataFlat(props) {
        return __awaiter(this, void 0, void 0, function* () {
            const tableCache = this.cache.getTableCache(props);
            if (props.topCount <= tableCache.loadedCount) {
                return tableCache.getRowsResult(props);
            }
            // load missing rows
            tableCache.dataColumns = props.dataColumns;
            tableCache.allColumns = props.allColumns;
            const nextRows = yield this.loader.loadData(Object.assign(Object.assign({}, props), { topCount: null, range: {
                    offset: tableCache.loadedCount,
                    limit: props.topCount - tableCache.loadedCount,
                } }));
            if (!nextRows) {
                // return tableCache.getRowsResult(props);
                return {
                    rows: [],
                    incomplete: false,
                };
            }
            if (nextRows.errorMessage) {
                throw new Error(nextRows.errorMessage);
            }
            tableCache.loadedRows = [...tableCache.loadedRows, ...nextRows];
            tableCache.loadedAll = nextRows.length < props.topCount - tableCache.loadedCount;
            // const rows=tableCache.getRows(props);
            return tableCache.getRowsResult(props);
        });
    }
    loadRowCount(props) {
        return __awaiter(this, void 0, void 0, function* () {
            const tableCache = this.cache.getTableCache(props);
            if (tableCache.allRowCount != null) {
                return tableCache.allRowCount;
            }
            const result = yield this.loader.loadRowCount(Object.assign({}, props));
            if (result.errorMessage) {
                throw new Error(result.errorMessage);
            }
            tableCache.allRowCount = parseInt(result.count);
            return tableCache.allRowCount;
        });
    }
}
exports.PerspectiveDataProvider = PerspectiveDataProvider;
